import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography, TextField } from "@mui/material";
import { API_BASE_URL } from "../config.ts";
import { useTranslation } from "react-i18next";
//import CssBaseline from "@mui/material/CssBaseline";

const LoginPage = () => {
    const { t } = useTranslation();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // --- Configure demo detection + demo credentials here ---
    const DEMO_HOSTNAME = "dacustomsserver20250119213101.azurewebsites.net"; // demo hostname 
    const DEMO_URL_FRAGMENT = "dacustomsserver20250119213101.azurewebsites.net"; // optional fallback check (full URL)
    const DEMO_EMAIL = "contact@dacustoms.eu"; // demo email value to auto-fill
    //const DEMO_PASSWORD = "demo"; // demo password value to auto-fill
    // --------------------------------------------------------

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        //console.log('process.release:', process.release);

        // Simulated login API call
        try {
            //const response = await axiosExt.get<T>(`${API_BASE_URL}/endpoint`);
            //const response = await fetch(`${API_BASE_URL}/auth/login", {
            const response = await fetch(`${API_BASE_URL}/auth/login`, {
               
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem("token", data.token);
                localStorage.setItem("roles", JSON.stringify(data.roles)); // Store user role
                localStorage.setItem("userId", data.userId);
                localStorage.setItem("language", data.language);
                navigate("/orderdetailspage?view=grid"); // Redirect to navigation page
            } else {
                setError("Invalid email or password");
            }
        } catch (error) {
            console.log(error);
            setError("An error occurred during login.");
        }
    };

    useEffect(() => {
        try {
            const host = typeof window !== "undefined" ? window.location.hostname : "";
            const href = typeof window !== "undefined" ? window.location.href : "";

            const isDemo =
                (host && host.toLowerCase() === DEMO_HOSTNAME.toLowerCase()) ||
                href.toLowerCase().includes(DEMO_URL_FRAGMENT.toLowerCase());

            if (isDemo) {
                setEmail(DEMO_EMAIL);
                //setPassword(DEMO_PASSWORD);
            }
        } catch (e) {
            // noop: defensive in case window is not available
            console.warn("Demo detection failed", e);
        }
    }, []);

    // Determine if we are on demo so we can optionally make fields readOnly or style differently
    const isDemoSite =
        (typeof window !== "undefined" &&
            (window.location.hostname.toLowerCase() === DEMO_HOSTNAME.toLowerCase() ||
                window.location.href.toLowerCase().includes(DEMO_URL_FRAGMENT.toLowerCase()))) ||
        false;



    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",       // Full viewport height
                backgroundColor: "#f5f5f5",  // Optional: light background
                width: "100vw",
            }}
        >
            <div
                style={{
                    width: "400px",
                    padding: "40px",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                }}
            >
                <Typography variant="h4" gutterBottom>
                    {t("Login to DACustoms")}
                </Typography>

                {/* Demo message shown under the title */}
                {isDemoSite && (
                    <Typography
                        variant="body2"
                        sx={{ marginBottom: 2 }}
                        data-demo-note="true"
                    >
                        Please email us <a href="mailto:contact@dacustoms.eu">contact@dacustoms.eu</a> for the password to access the demo.
                    </Typography>
                )}

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: "20px" }}>
                        <TextField
                            label={t("Email")}
                            variant="outlined"
                            fullWidth
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            margin="normal"
                        />
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <TextField
                            label={t("Password")}
                            type="password"
                            variant="outlined"
                            fullWidth
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            margin="normal"
                        />

                    </div>
                    <div>
                        <Button type="submit" variant="contained">
                            {t("Login")}
                        </Button>
                    </div>
                </form>
                {error && <p style={{ color: "red", marginTop: "20px" }}>{error}</p>}
            </div>
        </div>
    );


    /*return (
        <div style={{ width: "100%", alignContent:"center"}}>
            <h1>Login to DACustoms</h1>
            <form onSubmit={handleLogin}>
                <div>
                    <input
                        type="text"
                        placeholder="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <br></br>
                    <button type="submit" >Login</button>
                </div>
            </form>
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );*/
};

export default LoginPage;




/*import React from "react";
import { useMsal } from "@azure/msal-react";

const LoginPage = () => {
    const { instance } = useMsal();

    const handleLoginWithMicrosoft = () => {
        instance.loginPopup();
    };

    const handleLoginWithPassword = async (email, password) => {
        // Call backend API for username/password login
        const response = await fetch(`${API_BASE_URL}/auth/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
        });
        if (response.ok) {
            const data = await response.json();
            localStorage.setItem("token", data.token);
        }
    };

    return (
        <div>
            <button onClick={handleLoginWithMicrosoft}>
                Login with Microsoft
            </button>
            <form onSubmit={(e) => {
                e.preventDefault();
                const username = e.target.email.value;
                const password = e.target.password.value;
                handleLoginWithPassword(username, password);
            }}>
                <input type="text" name="email" placeholder="Email" required />
                <input type="password" name="password" placeholder="Password" required />
                <button type="submit">Login</button>
            </form>
        </div>
    );
};

export default LoginPage;*/
